import React, { useState, useEffect, useRef, Children } from "react"
import '../../assets/css/views/learning/colleagues.css'
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Select, Button, Table, TableData, TableColumns, TablePreferences, TableColumnWidth, SelectOption, SelectInterface, ContextualMenu, IconPencil, IconTrash, Modal, ButtonGroup, IconWarningAlt, OptionInterface, TextBox, IconPlus, IconMinus, IconRemoteControl, DatePicker, Tabs, List, ListItem, IconReload, Checkbox, Accordion, AccordionItemInterface, IconX, IconCheckmark, AccordionInterface, IconCheckmarkCircle, Card, CustomImage, ProgressIndicator, RadioButtons, RadioButton, IconXCircle } from "@veneer/core";

import { useSelector } from "react-redux";
import { RootState } from "../../app/store";
import colleaguesService from "../../services/trainingApi/colleagues.service";
import { IRankingColleaguesIn } from "../../models/input/trainingApi/IRankingColleaguesIn";
import { IFilterDto } from "../../models/dto/trainingApi/IFilterDto";
import { decryptText } from "../../utils/encryptionUtils";

//import flags
import flagArgentina from '../../assets/img/countries/argentina.png'
import flagBrazil from '../../assets/img/countries/brazil.png'
import flagChile from '../../assets/img/countries/chile.png'
import flagColombia from '../../assets/img/countries/colombia.png'
import flagCostaRica from '../../assets/img/countries/costa-rica.png'
import flagDominicana from '../../assets/img/countries/dominica.png'
import flagEcuador from '../../assets/img/countries/ecuador.png'
import flagElSalvador from '../../assets/img/countries/el-salvador.png'
import flagGuatemala from '../../assets/img/countries/guatemala.png'
import flagHonduras from '../../assets/img/countries/honduras.png'
import flagMexico from '../../assets/img/countries/mexico.png'
import flagNicaragua from '../../assets/img/countries/nicaragua.png'
import flagNotFound from '../../assets/img/countries/not-found.png'
import flagPanama from '../../assets/img/countries/panama.png'
import flagPeru from '../../assets/img/countries/peru.png'
import flagRepublicaDominicana from '../../assets/img/countries/republica-dominicana.png'



export default function Colleagues() {

    const params = useParams();
    const [t] = useTranslation("global");
    const languageId: any = useSelector((state: RootState) => state.languageId);
    const state: any = useSelector((state: RootState) => state.user);
    type SelectValue = number | string | boolean; //CHECK


    //data
    const [regionCheckList, setRegionCheckList] = useState<IFilterDto[]>([]);
    const [coursesCheckList, setcoursesCheckList] = useState<IFilterDto[]>([]);
    const [tableData, setTableData] = useState<TableData[]>([]);


    //selects
    const [regionSelected, setRegionSelected] = useState<string>('');
    const [coursesSelected, setCoursesSelected] = useState<string[]>([]);

    //booleans
    const [loadingTable, setLoadingTable] = useState<boolean>(false);

    const flags: { [key: string]: string } = {
        argentina: flagArgentina,
        brazil: flagBrazil,
        chile: flagChile,
        colombia: flagColombia,
        'costa-rica': flagCostaRica,
        dominica: flagDominicana,
        ecuador: flagEcuador,
        'el-salvador': flagElSalvador,
        guatemala: flagGuatemala,
        honduras: flagHonduras,
        mexico: flagMexico,
        nicaragua: flagNicaragua,
        panama: flagPanama,
        peru: flagPeru,
        'republica-dominicana': flagRepublicaDominicana,
      };

    useEffect(() => {
        getFilterData()
    }, []);

    useEffect(() => {
        if (regionSelected) {
            getRankingData()
        }
    }, [regionSelected, coursesSelected]);

    const getFilterData = () => {
        colleaguesService.getRankingColleaguesFilter()
            .then((r: IFilterDto[]) => {
                let regions = r.filter(item => item.filterID != 4);
                let courses = r.filter(item => item.filterID == 4);
                setRegionCheckList(regions)
                setcoursesCheckList(courses)
                setRegionSelected(String(0))
            })
    }


    const getRankingData = () => {
        setLoadingTable(true)
        let coursesTemp = [];
        if (coursesSelected.length > 0) {
            for (let i = 0; i < coursesSelected.length; i++) {
                coursesTemp.push(coursesCheckList[Number(coursesSelected[i])].filterValue)
            }
        }
        let rankingColleaguesIn: IRankingColleaguesIn = {
            userID: Number(decryptText(state.user.userId)),
            filterID: regionCheckList[Number(regionSelected)].filterID,
            filterValue: regionCheckList[Number(regionSelected)].filterValue,
            courses: String(coursesTemp)
        }
        colleaguesService.getRankingColleagues(rankingColleaguesIn)
            .then(r => {
                fillFlags(r)
            })
    }

    const fillFlags = (data: any[]) => {
        for (let i = 0; i < data.length; i++) {
          const countryKey = data[i].countryName.toLowerCase().replace(" ", "-");
      
          data[i].flag = (
            <div>
              <img
                className="colleaguesImagesCountries"
                src={flags[countryKey] || flagNotFound}
                alt={`${data[i].countryName} flag`}
              />
            </div>
          );
        }
      
        setTableData(data);  
        setLoadingTable(false);  
      };

    const columns: TableColumns[] = [
        {
            id: 'flag',
            label: t("header.country"),
        },
        {
            id: 'userName',
            label: t("header.name"),
        },
        {
            id: 'score',
            label: t("header.score"),
        },

    ];

    const columnsWidth: TableColumnWidth[] = [

        {
            columnId: 'flag',
            width: "10%"
        },
        {
            columnId: 'userName',
            width: "70%"
        },
        {
            columnId: 'score',
            width: "20%"
        },


    ]

    const tablePreferences: TablePreferences = {
        width: columnsWidth
    }



    const handleChangeRegion = (value: string) => {
        setRegionSelected(value);

    };

    const handleChangeCourses = (value: string) => {
        const coursesSelectedTemp = coursesSelected;
        if (coursesSelectedTemp.includes(value)) {
            setCoursesSelected(coursesSelectedTemp.filter(item => item != value))
        } else {
            coursesSelectedTemp.push(value);
            setCoursesSelected([...coursesSelectedTemp])
        }

    };





    return (
        <>
            <div className="colleaguesDiv">

                <div>

                    {tableData.length > 0 && tableData.some(item => item.positionFlag === true) ?
                        <Card
                            appearance="outlined"
                            className="colleaguesUserCard"
                            content={
                                <div className="colleaguesFilterUserInfo">
                                    <strong>{tableData.find(item => item.positionFlag === true)!.userName}</strong>
                                    <p>{t("header.score") + ": " + tableData.find(item => item.positionFlag === true)!.score}</p>
                                    <p>{t("header.position") + ": " + tableData.find(item => item.positionFlag === true)!.position}</p>
                                </div>
                            }
                        />
                        : <Card
                            appearance="outlined"
                            className="colleaguesUserCard"
                            content={
                                <div className="colleaguesFilterUserInfo">
                                    <strong>{t("header.name")}:  {decryptText(state.user.name)}  {decryptText(state.user.lastName)} </strong>
                                    <p>{t("header.score") + ": "} <strong>-</strong></p>
                                    <p>{t("header.position") + ": "} <strong>-</strong></p>

                                </div>
                            }
                        />

                    }

                    <Card
                        appearance="outlined"
                        className="colleaguesCard"
                        content={
                            <div>
                                <Table
                                    className="colleaguesTable"
                                    behavior={{
                                        type: 'singlePage',
                                    }}
                                    columnResize
                                    preferences={tablePreferences}
                                    loading={loadingTable}
                                    columns={columns}
                                    data={tableData}
                                    loadingDataLength={10}
                                    customNoItems={<div className="customNoItems"><div className="DivIconCustomNoItems"><IconWarningAlt className="IconCustomNoItems" /></div>{t("header.noItemsFound")}</div>}
                                />


                            </div>
                        }
                    />
                </div>
                <Card
                    appearance="outlined"
                    className="colleaguesFiltersCard"
                    content={
                        <div>
                            <h6>{t("header.region")}</h6>
                            <div className="colleaguesRegions">
                                <RadioButtons alignment="vertical" name="radiobuttonRegions" value={regionSelected}>
                                    {regionCheckList.map((item, index) => {
                                        return <RadioButton id={`radio${index}`} value={String(index)} label={item.filterName} onClick={() => handleChangeRegion(String(index))} />
                                    })}
                                </RadioButtons>
                            </div>
                            <hr></hr>
                            <h6>{t("header.courses")}</h6>
                            <div className="colleaguesCourses">
                                {coursesCheckList.map((item, index) => {
                                    return <Checkbox
                                        className="colleguesCoursesCheckbox"
                                        id={String(index)}
                                        label={item.filterName}
                                        onClick={() => handleChangeCourses(String(index))}
                                    />
                                })}
                            </div>
                        </div>
                    }
                />

            </div>


        </>


    );
}